export function attachCollectionListeners() {
  let productCards = document.querySelectorAll(".section-featured-collection .product-item a");

  if(productCards) {
    productCards.forEach(card => {
      card.addEventListener("click", pushGTMData);
    })
  }
}

function pushGTMData(event) {
  let currentCard = event.currentTarget.closest(".product-item");
  let productName = currentCard.querySelector(".product-item-title-link").innerText;

  dataLayer.push({
    'event': 'gtm-click',
    'clickType': 'product click',
    'clickName': 'featured products',
    'productName': productName.replace(/'/g,"")
  })
}